import { useCallback, useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { buildHistoryFieldOptions } from './AdminPromptFields';

export function useHistoryFieldOptions() {
  const [options, setOptions] = useState([]);
  const [hiddenCount, setHiddenCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const retry = useCallback(() => setRevision(value => value + 1), []);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    const unsubscribe = onSnapshot(collection(db, 'documentDataFields'), snapshot => {
      if (!active) return;
      const fields = snapshot.docs.map(item => ({ ...item.data(), id: item.id }));
      setOptions(buildHistoryFieldOptions(fields));
      setHiddenCount(fields.filter(field => field.showInHistoryFields === false).length);
      setLoading(false);
      setError(false);
    }, () => {
      if (!active) return;
      setError(true);
      setLoading(false);
    });
    return () => { active = false; unsubscribe(); };
  }, [revision]);

  return { options, hiddenCount, loading, error, retry };
}
